import { render, staticRenderFns } from "./AppWorkAnalyzerSeedingTable.vue?vue&type=template&id=244789df&scoped=true&"
import script from "./AppWorkAnalyzerSeedingTable.vue?vue&type=script&lang=js&"
export * from "./AppWorkAnalyzerSeedingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244789df",
  null
  
)

export default component.exports